import { Spinner } from 'react-bootstrap';
import '../../styles.css';

function LoaderWheel() {
  return <Spinner animation="border" />;
}

export default LoaderWheel;
